import { ValidationErrors } from 'final-form';
import {
  DateRangeValidationMessages,
  hasValidDateRange,
  resolveValidationLabel,
  validateReportDateRange
} from '../utils/reportValidation';

interface ReportValidationMessages extends DateRangeValidationMessages {
  organizationCodeRequired: string;
  reportNameRequired: string;
  reportMonthRequired: string;
  reportYearRequired: string;
}

const getValidationMessages = (labels?: unknown): ReportValidationMessages => ({
  organizationCodeRequired: resolveValidationLabel(labels, ['formErrors.organizationCodeRequired', 'validationErrors.organizationCodeRequired'], 'Please select agency name/code'),
  reportNameRequired: resolveValidationLabel(labels, ['formErrors.reportNameRequired', 'validationErrors.reportNameRequired'], 'Please select report name'),
  reportMonthRequired: resolveValidationLabel(labels, ['formErrors.reportMonthRequired', 'validationErrors.reportMonthRequired'], 'Please select report month'),
  reportYearRequired: resolveValidationLabel(labels, ['formErrors.reportYearRequired', 'validationErrors.reportYearRequired'], 'Please select report year'),
  reportEndDateRequired: resolveValidationLabel(labels, ['formErrors.reportEndDateRequired', 'validationErrors.reportEndDateRequired'], 'Please select an end date'),
  reportStartDateRequired: resolveValidationLabel(labels, ['formErrors.reportStartDateRequired', 'validationErrors.reportStartDateRequired'], 'Please select a start date'),
  startDateFuture: resolveValidationLabel(labels, ['formErrors.startDateFuture', 'validationErrors.startDateFuture'], 'Start date cannot be in the future'),
  endDateFuture: resolveValidationLabel(labels, ['formErrors.endDateFuture', 'validationErrors.endDateFuture'], 'End date cannot be in the future'),
  startDateAfterEndDate: resolveValidationLabel(labels, ['formErrors.startDateAfterEndDate', 'validationErrors.startDateAfterEndDate'], 'Start date cannot be after end date'),
  dateRangeExceeded365Days: resolveValidationLabel(labels, ['formErrors.dateRangeExceeded365Days', 'validationErrors.dateRangeExceeded365Days'], 'Date range cannot exceed 365 days')
});

const requireFields = (value, messages: ReportValidationMessages): ValidationErrors => {
  const hasDateRange = hasValidDateRange(value);
  return {
    ...(!value.organizationCode && { organizationCode: messages.organizationCodeRequired }),
    ...(!value.reportName && { reportName: messages.reportNameRequired }),
    ...(!hasDateRange && !value.reportMonth && { reportMonth: messages.reportMonthRequired }),
    ...(!hasDateRange && !value.reportYear && { reportYear: messages.reportYearRequired })
  };
};

export default function (value, labels?: unknown): ValidationErrors {
  const errors: { [prop: string]: unknown } = {};
  const messages = getValidationMessages(labels);

  return {
    ...requireFields(value, messages),
    ...validateReportDateRange(value, messages),
    ...errors
  };
}
